(function () {
  var burger = document.getElementById('lux-nav-burger');
  var drawer = document.getElementById('lux-mobile-drawer');
  if (!burger || !drawer) return;

  var closers = drawer.querySelectorAll('[data-lux-drawer-close]');

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    burger.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    if (window.__luxLenis) window.__luxLenis.stop();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    burger.classList.remove('is-active');
    document.body.style.overflow = '';
    if (window.__luxLenis) window.__luxLenis.start();
  }

  burger.addEventListener('click', function () {
    if (drawer.classList.contains('is-open')) closeDrawer();
    else openDrawer();
  });

  closers.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
